<div class="create-configuration-container">
  <app-promotion-method-description [isFormValidated]="isFormValidated" (promotionData)="fieldsValues = $event" [isFormSubmitted]="submitted">
  </app-promotion-method-description>
  <div class="create-configuration-button-container">
    <button class="create-configuration-button" (click)="verifyForm()">
      <span>
        <nb-icon class="plus-icon" icon="plus" pack="icomoon"></nb-icon>
        {{ 'view_translations.add_promotion' | translate }}
      </span>
    </button>
  </div>
</div>
